<template>
  <div id="andamentosOuvidoria">
    <b-card header-tag="header" class="m-3" no-body>
      <template #header>
        <div
          class="d-flex justify-content-between align-items-center px-3 py-2"
        >
          <h5 class="mb-0">Histórico de andamentos</h5>
          <b-button
            v-if="!somenteVisualizacao"
            size="sm"
            variant="outline-secondary"
            @click="abrirModal"
          >
            <font-awesome-icon icon="plus" class="mr-1" />
            Adicionar Andamento
          </b-button>
        </div>
      </template>
      <b-card-body>
        <div v-for="(and, idx) in andamentos" :key="and.idAndamento ?? idx">
          <b-row
            :class="
              and.tipo == 'Resposta'
                ? 'mx-0 my-2 justify-content-end'
                : 'mx-0 justify-content-start'
            "
          >
            <b-col cols="12" md="6" class="px-1 mb-2">
              <b-card class="h-100" rounded no-body>
                <div
                  class="p-2 d-flex justify-content-between align-items-start border-bottom"
                >
                  <div>
                    <div class="font-weight-bold text-left">
                      Tipo: {{ and.tipo }}
                    </div>
                    <small class="text-muted text-left"
                      >Status: {{ and.status }}</small
                    >
                  </div>
                  <small class="text-muted">{{
                    formatDataHora(and.dataHora)
                  }}</small>
                </div>
                <b-card-body>
                  <p class="mb-0">{{ and.descricao }}</p>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>

    <ModalAdicionarAndamento
      v-if="modalAbertoAndamento"
      :titulo="tituloModal"
      :idManifestacao="idManifestacao"
      @reload="loadAndamentos"
      @close="closeModalAndamento"
    />
  </div>
</template>

<script lang="ts">
import ouvidoriaService from "@/services/administracao/ouvidoriaService";
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import { Andamento } from "@/types/administracao/ouvidoria/andamento";
import ModalAdicionarAndamento from "./ModalAdicionarAndamento.vue";

const CompProps = Vue.extend({
  name: "AndamentosOuvidoria",
  components: {
    ModalAdicionarAndamento,
  },
  props: {
    idManifestacao: {
      type: Number,
      required: true,
    },
    numManifestacao: {
      type: Number,
      required: true,
    },
    anoManifestacao: {
      type: Number,
      required: true,
    },
  },
});

@Component
export default class AndamentosOuvidoria extends mixins(UtilsTS, CompProps) {
  andamentos: Andamento[] = [];
  modalAbertoAndamento = false;
  tituloModal = "";

  get somenteVisualizacao(): boolean {
    return this.$route.path.startsWith('/mural-avisos/manifestacoes');
  }

  async loadAndamentos(): Promise<void> {
    try {
      this.andamentos = await ouvidoriaService.listarAndamentos(
        Number(this.idManifestacao)
      );
    } catch (error: unknown) {
      this.tratarError(error);
    }
  }

  async mounted(): Promise<void> {
    await this.loadAndamentos();
  }

  closeModalAndamento() {
    this.modalAbertoAndamento = false;
  }

  abrirModal() {
    this.tituloModal = `Adiconar andamento à Manifestação ${this.numManifestacao}/${this.anoManifestacao} `;
    this.modalAbertoAndamento = true;
  }
}
</script>

<style scoped>
div span:first-of-type {
  font-weight: bold;
}
</style>
